import React from "react";
import { ShoppingCart, Minus, Plus } from "lucide-react";
import QuantityStepper from "./ProductDetailComponent.tsx/QuantityStepper";

interface CartButtonProps {
  qty: number;
  onAdd: () => void;
  onIncrement: () => void;
  onDecrement: () => void;
  title?: string;
  buttonclass?: string;
  variant?: "icon" | "full";
  size?: "sm" | "md";
  buttonInnerclass?: string
}

const CartButton: React.FC<CartButtonProps> = ({
  qty,
  onAdd,
  onIncrement,
  onDecrement,
  title,
  buttonclass = "",
  variant = "icon",
  size = "md",
  buttonInnerclass = ""
}) => {


  const sizeStyles = {
    sm: {
      btn: "w-8 h-8",
      icon: 18,
    },
    md: {
      btn: "w-10 h-10",
      icon: 24,
    },
  };

  const currentSize = sizeStyles[size || "md"];

  if (variant === "icon") {
    if (qty === 0) {
      return (
        <button
          onClick={onAdd}
          className={`${currentSize.btn} flex items-center justify-center rounded-full bg-logoHeading text-white`}
        >
          <Plus size={currentSize.icon} />
        </button>
      );
    }

    return (
      <div className="flex items-center gap-2 bg-logoHeading rounded-full px-2 py-1">
        <button onClick={onDecrement}>
          <Minus size={currentSize.icon - 4} className="text-white" />
        </button>
        <span className="text-base text-white">{qty}</span>
        <button onClick={onIncrement}>
          <Plus size={currentSize.icon - 4} className="text-white" />
        </button>
      </div>
    );
  }

  if (variant === "full") {
    return (
      <div className={`w-full flex flex-col gap-2 ${buttonclass}`}>

        {/* SHOW STEPPER ONLY WHEN qty > 0 */}
        <div className="pb-2">
          <QuantityStepper
            qty={qty}
            onIncrement={onIncrement}
            onDecrement={onDecrement}
            className="w-full"
          />
        </div>
      </div>
    );
  }
  return null
};

export default CartButton;